// Generated by scripts/build-storefront.py. Edit src/storefront.js instead.
// Self-contained: display and approved sizing grids always share one asset version.
(() => {
const DROP_DATE = '2026-10-14T20:00:00+02:00';
const DROP_ID = 'october-2026';
function escapeHTML(value = '') {
  return String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
}
function safeURL(value, base = 'https://weyzclothing.com') {
  try { const url = new URL(value, base); return ['https:', 'http:'].includes(url.protocol) ? url.href : ''; } catch { return ''; }
}
function recommend(profile, rules, sizes) {
  if (!profile || !Number.isFinite(profile.height) || !Number.isFinite(profile.weight)) return null;
  const matches = (rules || []).filter(r => profile.height >= r.minHeight && profile.height < r.maxHeight && profile.weight >= r.minWeight && profile.weight < r.maxWeight);
  // Ambiguous or missing rules must never produce an invented recommendation.
  if (matches.length !== 1) return null;
  const value = matches[0][profile.fit === 'oversize' ? 'oversize' : 'regular'];
  return sizes.includes(value) ? value : null;
}
// The final WEYZ workbook uses reference measurements, not lower-bound bands.
// Equal distances select the upper reference; never extend a grid beyond its axes.
function recommendGrid(profile, grid, sizes) {
  if (!profile || !grid || !Number.isFinite(profile.height) || !Number.isFinite(profile.weight)) return null;
  const {height, weight} = profile;
  const {heightsCm, weightsKg, outside} = grid;
  let value;
  if (height > outside.heightGreaterThan && weight > outside.weightGreaterThan) {
    value = outside.regular;
  } else {
    if (height < heightsCm[0] || height > heightsCm.at(-1) || weight < weightsKg[0] || weight > weightsKg.at(-1)) return null;
    const nearest = (axis, n) => axis.reduce((best, point, index) => Math.abs(point - n) <= Math.abs(axis[best] - n) ? index : best, 0);
    value = grid.regular[nearest(weightsKg, weight)]?.[nearest(heightsCm, height)];
  }
  if (!value) return null;
  if (profile.fit === 'oversize') {
    const order = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
    const index = order.indexOf(value);
    value = index < 0 ? null : order[index + grid.oversizeSteps];
    if (!value) return null;
  }
  // Keep the actual Shopify label; 2XL and XXL denote the same size.
  const canonical = size => ({XXL:'2XL', XXXL:'3XL'}[String(size).trim().toUpperCase()] || String(size).trim().toUpperCase());
  return sizes.find(size => canonical(size) === value) ?? null;
}
function recommendProduct(profile, product) {
  if (product.noSizing) return null;
  const sizes = product.variants.map(v => v.size);
  if (product.sizeGuide && product.sizeGuide !== 'custom') return recommendGrid(profile, SIZE_GRIDS[product.sizeGuide], sizes);
  return recommend(profile, product.rules, sizes);
}
function ruleErrors(rules) {
  const errors = [];
  rules.forEach((r, i) => {
    if (![r.minHeight,r.maxHeight,r.minWeight,r.maxWeight].every(Number.isFinite) || r.minHeight >= r.maxHeight || r.minWeight >= r.maxWeight) errors.push(`Invalid bounds: ${i+1}`);
    rules.slice(0,i).forEach((p,j) => { if (r.minHeight < p.maxHeight && r.maxHeight > p.minHeight && r.minWeight < p.maxWeight && r.maxWeight > p.minWeight) errors.push(`Overlapping rules: ${j+1}, ${i+1}`); });
  });
  return errors;
}
function displayHeight(cm, us) {
  if (!us) return `${(cm / 100).toFixed(2)} m`;
  const inches = Math.round(cm / 2.54);
  return `${Math.floor(inches / 12)}′ ${inches % 12}″`;
}
function displayWeight(kg, us) { return `${us ? Math.round(kg * 2.2046226218) : Math.round(kg * 10) / 10} ${us ? 'lbs' : 'kg'}`; }
function normalizeLines(lines, catalog) {
  if (!Array.isArray(lines) || lines.length > 40) throw new Error('Invalid selection');
  const variants = new Set(catalog.flatMap(p => p.variants.map(v => String(v.id))));
  const map = new Map();
  for (const line of lines) {
    const id = String(line.variantId);
    if (!variants.has(id) || !Number.isInteger(line.quantity) || line.quantity < 1 || line.quantity > 10) throw new Error('Invalid variant or quantity');
    const quantity = (map.get(id) || 0) + line.quantity;
    if (quantity > 10) throw new Error('Quantity limit');
    map.set(id, quantity);
  }
  return [...map].map(([variantId,quantity]) => ({variantId,quantity}));
}
function findVariant(catalog, id) {
  for (const product of catalog) { const variant = product.variants.find(v => String(v.id) === String(id)); if (variant) return {product,variant}; }
  return null;
}
function summary(lines, catalog) {
  return lines.map(line => { const found=findVariant(catalog,line.variantId); return found ? {...line,title:found.product.title,size:found.variant.size,color:found.product.color || '',price:found.variant.price,image:found.product.image,handle:found.product.handle} : null; }).filter(Boolean);
}
function readLocal(key, storage) { try { return JSON.parse((storage || globalThis.localStorage).getItem(key)) || null; } catch { return null; } }
function writeLocal(key, value, storage) { try { (storage || globalThis.localStorage).setItem(key, JSON.stringify(value)); return true; } catch { return false; } }

// BEGIN WEYZ APPROVED GRIDS — source: WEYZ-Grilles-tailles-FINAL.xlsx, 2026-10-05
const SIZE_GRIDS = {
  "gilet": {
    "heightsCm": [
      160,
      165,
      170,
      175,
      180,
      185,
      190,
      195
    ],
    "weightsKg": [
      50,
      55,
      60,
      65,
      70,
      75,
      80,
      85,
      90,
      95
    ],
    "regular": [
      [
        "XS",
        "XS",
        "XS",
        "XS",
        "S",
        "S",
        "M",
        "L"
      ],
      [
        "XS",
        "XS",
        "XS",
        "S",
        "S",
        "S",
        "M",
        "L"
      ],
      [
        "XS",
        "XS",
        "S",
        "S",
        "M",
        "M",
        "M",
        "L"
      ],
      [
        "XS",
        "XS",
        "S",
        "S",
        "M",
        "M",
        "L",
        "L"
      ],
      [
        "XS",
        "S",
        "S",
        "S",
        "M",
        "M",
        "L",
        "L"
      ],
      [
        "S",
        "S",
        "M",
        "M",
        "M",
        "M",
        "L",
        "L"
      ],
      [
        "S",
        "S",
        "M",
        "M",
        "L",
        "L",
        "L",
        "XL"
      ],
      [
        "S",
        "S",
        "M",
        "M",
        "L",
        "L",
        "L",
        "XL"
      ],
      [
        "M",
        "M",
        "L",
        "L",
        "L",
        "L",
        "XL",
        "XL"
      ],
      [
        "M",
        "M",
        "L",
        "L",
        "XL",
        "XL",
        "XL",
        "XL"
      ]
    ],
    "oversizeSteps": 1,
    "outside": {
      "heightGreaterThan": 195,
      "weightGreaterThan": 95,
      "operator": "AND",
      "regular": "2XL",
      "source": "B22:H22"
    }
  },
  "hoodie": {
    "heightsCm": [
      160,
      165,
      170,
      175,
      180,
      185,
      190,
      195
    ],
    "weightsKg": [
      50,
      55,
      60,
      65,
      70,
      75,
      80,
      85,
      90,
      95
    ],
    "regular": [
      [
        "XS",
        "XS",
        "XS",
        "XS",
        "S",
        "M",
        "L",
        "L"
      ],
      [
        "XS",
        "XS",
        "XS",
        "S",
        "S",
        "M",
        "L",
        "L"
      ],
      [
        "XS",
        "XS",
        "S",
        "S",
        "M",
        "M",
        "L",
        "L"
      ],
      [
        "S",
        "S",
        "S",
        "S",
        "M",
        "M",
        "L",
        "L"
      ],
      [
        "S",
        "S",
        "M",
        "M",
        "M",
        "L",
        "L",
        "L"
      ],
      [
        "M",
        "M",
        "M",
        "M",
        "L",
        "L",
        "L",
        "L"
      ],
      [
        "M",
        "M",
        "M",
        "L",
        "L",
        "L",
        "L",
        "L"
      ],
      [
        "M",
        "M",
        "M",
        "L",
        "L",
        "L",
        "XL",
        "XL"
      ],
      [
        "L",
        "L",
        "L",
        "XL",
        "XL",
        "XL",
        "XL",
        "XL"
      ],
      [
        "L",
        "L",
        "XL",
        "XL",
        "XL",
        "XL",
        "XL",
        "XL"
      ]
    ],
    "oversizeSteps": 1,
    "outside": {
      "heightGreaterThan": 195,
      "weightGreaterThan": 95,
      "operator": "AND",
      "regular": "2XL",
      "source": "B22:H22"
    }
  },
  "jean": {
    "heightsCm": [
      160,
      165,
      170,
      175,
      180,
      185,
      190,
      195
    ],
    "weightsKg": [
      50,
      55,
      60,
      65,
      70,
      75,
      80,
      85,
      90,
      95
    ],
    "regular": [
      [
        "XS",
        "XS",
        "XS",
        "XS",
        "S",
        "M",
        "L",
        "L"
      ],
      [
        "XS",
        "XS",
        "XS",
        "S",
        "S",
        "M",
        "L",
        "L"
      ],
      [
        "XS",
        "XS",
        "S",
        "S",
        "S",
        "M",
        "L",
        "L"
      ],
      [
        "S",
        "S",
        "S",
        "S",
        "M",
        "M",
        "L",
        "L"
      ],
      [
        "S",
        "S",
        "S",
        "M",
        "M",
        "M",
        "L",
        "L"
      ],
      [
        "M",
        "M",
        "M",
        "M",
        "L",
        "L",
        "L",
        "L"
      ],
      [
        "M",
        "M",
        "M",
        "L",
        "L",
        "L",
        "L",
        "L"
      ],
      [
        "M",
        "M",
        "M",
        "L",
        "L",
        "L",
        "XL",
        "XL"
      ],
      [
        "L",
        "L",
        "L",
        "XL",
        "XL",
        "XL",
        "XL",
        "XL"
      ],
      [
        "L",
        "L",
        "XL",
        "XL",
        "XL",
        "XL",
        "XL",
        "XL"
      ]
    ],
    "oversizeSteps": 1,
    "outside": {
      "heightGreaterThan": 195,
      "weightGreaterThan": 95,
      "operator": "AND",
      "regular": "2XL",
      "source": "B22:H22"
    }
  }
};
// END WEYZ APPROVED GRIDS

const esc = escapeHTML;

const TEXT={
  "en": {
    "discover": "Discover the collection",
    "alertOnly": "I just want to be alerted",
    "pick": "CHECK OUT THE NEW COLLECTION",
    "intro": "Discover the collection, piece by piece and discover your sizing.",
    "colors": "Available in {n} colors.",
    "model": "Model",
    "pickSize": "Pick my size",
    "suggested": "Suggested size",
    "email": "Enter your email address",
    "height": "How tall are you?",
    "heightHint": "Give us your height.",
    "weight": "How much do you weigh?",
    "weightHint": "Give us your weight.",
    "fit": "How do you like your fit?",
    "fitHint": "Give us your preference.",
    "regular": "Regular",
    "regularHint": "(fit like the model on the pictures)",
    "oversize": "Oversize",
    "enter": "Enter",
    "miss": "Don’t miss the release",
    "receive": "Be the first to be alerted",
    "subscribe": "Subscribe to alert",
    "whatsapp": "Subscribe on WhatsApp",
    "alertConsent": "Receive the reminder for this collection by email. Unsubscribe at any time.",
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "live": "The drop is live",
    "close": "Close",
    "previous": "Previous",
    "next": "Next",
    "invalid": "Please check your measurements.",
    "noRules": "No recommendation available for these measurements.",
    "privacy": "Privacy policy",
    "soundOn": "Sound on",
    "soundOff": "Sound off",
    "videoMissing": "This product video has not been added yet.",
    "preview": "LOCAL PREVIEW — sample prices and images. Final WEYZ sizing grids. No email is sent.",
    "review": "Customer reviews",
    "getSize": "Get your size here",
    "youAre": "You are",
    "modify": "Modify your size",
    "yourSize": "Your size",
    "colorways": "Colorways",
    "deliveryTitle": "Delivery in 3 to 5 days in Europe",
    "deliveryHint": "Receive your order fast",
    "paymentTitle": "Secure payment",
    "paymentHint": "Credit card, Apple Pay, Google Pay, PayPal, etc.",
    "teamTitle": "A team that is here for you",
    "teamHint": "A question?",
    "contact": "Contact us by email",
    "previewSent": "Preview only — no registration or email was sent."
  },
  "fr": {
    "discover": "Découvrir la collection",
    "alertOnly": "Je veux simplement être prévenu",
    "pick": "EXPLORE LA NOUVELLE COLLECTION",
    "intro": "Découvre la collection, pièce par pièce, et trouve ta taille.",
    "colors": "Disponible en {n} coloris.",
    "model": "Modèle",
    "pickSize": "Trouver ma taille",
    "suggested": "Taille conseillée",
    "email": "Ton adresse email",
    "height": "Quelle est ta taille ?",
    "heightHint": "Indique ta taille.",
    "weight": "Combien pèses-tu ?",
    "weightHint": "Indique ton poids.",
    "fit": "Quel porté préfères-tu ?",
    "fitHint": "Indique ta préférence.",
    "regular": "Classique",
    "regularHint": "(même porté que le modèle sur les photos)",
    "oversize": "Large",
    "enter": "Valider",
    "miss": "Ne manque pas le lancement",
    "receive": "Soit le premier à être alerté",
    "subscribe": "M’inscrire à l’alerte",
    "whatsapp": "M’inscrire sur WhatsApp",
    "alertConsent": "Recevoir le rappel de ce drop par email. Désinscription à tout moment.",
    "days": "Jours",
    "hours": "Heures",
    "minutes": "Minutes",
    "seconds": "Secondes",
    "live": "Le drop est ouvert",
    "close": "Fermer",
    "previous": "Précédent",
    "next": "Suivant",
    "invalid": "Vérifie tes mensurations.",
    "noRules": "Aucune recommandation disponible pour ces mensurations.",
    "privacy": "Confidentialité",
    "soundOn": "Activer le son",
    "soundOff": "Couper le son",
    "videoMissing": "La vidéo de cette pièce n’a pas encore été ajoutée.",
    "preview": "APERÇU LOCAL — prix et photos illustratifs. Grilles de taille finales WEYZ. Aucun email envoyé.",
    "review": "Avis clients",
    "getSize": "Trouve ta taille ici",
    "youAre": "Tes mensurations",
    "modify": "Modifier mes mensurations",
    "yourSize": "Ta taille",
    "colorways": "Coloris",
    "deliveryTitle": "Livraison en 2 à 3 jours en France",
    "deliveryHint": "Reçois rapidement ta commande",
    "paymentTitle": "Paiement sécurisé",
    "paymentHint": "Carte bancaire, Apple Pay, Google Pay, PayPal, etc.",
    "teamTitle": "Une équipe à ton écoute",
    "teamHint": "Une question ?",
    "contact": "Contacte-nous par email",
    "previewSent": "Aperçu uniquement — aucune inscription ni aucun email envoyé."
  }
};
class WeyzOctober extends HTMLElement {
 connectedCallback(){if(!this.ready){this.ready=true;this.c=JSON.parse(this.querySelector('[data-wo-config]').textContent);this.lang=(this.c.locale||'en').startsWith('fr')?'fr':'en';this.catalog=this.c.products||[];this.profile=null;this.us=false;}this.abort=new AbortController();this.heroQuery=matchMedia("(max-width:799px)");this.render();this.bind();this.timer=setInterval(()=>this.countdown(),1000);}
 disconnectedCallback(){this.clearGallery();clearInterval(this.timer);clearTimeout(this.toastTimer);this.abort?.abort();this.querySelectorAll("video").forEach(v=>{v.muted=true;v.pause();});this.observers?.forEach(o=>o.disconnect());}
 t(k){return TEXT[this.lang][k]||k;}
 soundIcon(){return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9h4l5-4v14l-5-4H4z"/><path class="wo-sound-waves" d="M16 8a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14"/><path class="wo-sound-muted" d="m3 3 18 18"/></svg>';}
 centerLookbook(index,behavior='instant'){
  const track=this.querySelector('.wo-lookbook');if(!track?.children.length)return;
  this.lookbookIndex=Math.max(0,Math.min(index,track.children.length-1));
  const slide=track.children[this.lookbookIndex],box=slide.getBoundingClientRect(),frame=track.getBoundingClientRect();
  track.scrollTo({left:track.scrollLeft+box.left-frame.left-(track.clientWidth-box.width)/2,behavior});
  this.querySelectorAll('[data-lookbook-dot]').forEach((b,i)=>b.setAttribute('aria-current',String(i===this.lookbookIndex)));
 }
 price(cents){return new Intl.NumberFormat(this.lang==='fr'?'fr-FR':'en-IE',{style:'currency',currency:this.c.currency||'EUR'}).format(cents/100);}
 image(url,cls,alt=''){return url?`<img class="${cls}" src="${esc(safeURL(url,location.href))}" alt="${esc(alt)}" loading="lazy">`:`<div class="${cls} wo-placeholder">WEYZ</div>`;}
 media(video,poster,cls){return `<div class="wo-hero-media ${cls}">${video?`<video autoplay loop muted playsinline disablepictureinpicture disableremoteplayback preload="metadata" ${poster?`poster="${esc(poster)}"`:''}><source src="${esc(video)}" type="video/mp4"></video>`:poster?`<img src="${esc(poster)}" alt="" fetchpriority="high">`:''}</div>`;}
 heroSource(){
  const c=this.c,mobile=this.heroQuery.matches;
  return mobile?{video:c.heroMobile||c.heroVideo,poster:c.heroMobilePoster||c.heroPoster}:{video:c.heroVideo||c.heroMobile,poster:c.heroPoster||c.heroMobilePoster};
 }
 updateSoundButton(){
  const video=this.querySelector('.wo-hero video'),button=this.querySelector('[data-action="sound"]');if(!video||!button)return;
  const blocked=this.heroBlocked;
  button.setAttribute('aria-label',blocked?(this.lang==='fr'?'Lire la vidéo':'Play video'):this.t(video.muted?'soundOn':'soundOff'));
  button.setAttribute('aria-pressed',String(!video.muted&&!blocked));
  button.innerHTML=blocked?'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m8 5 11 7-11 7z" fill="currentColor"/></svg>':this.soundIcon();
 }
 playHero(){
  const video=this.querySelector('.wo-hero video');if(!video||this.modal||document.hidden)return;
  const failed=()=>{if(!this.isConnected||this.modal||document.hidden||this.querySelector('.wo-hero video')!==video)return;video.muted=true;this.heroBlocked=true;this.updateSoundButton();};
  try{video.play()?.catch(failed);}catch{failed();}
 }
 setupHero(){
  const video=this.querySelector('.wo-hero video');this.heroBlocked=false;if(!video)return;
  video.muted=true;video.playsInline=true;video.controls=false;
  video.addEventListener('playing',()=>{this.heroBlocked=false;this.updateSoundButton();},{signal:this.abort.signal});
  video.addEventListener('pause',()=>{if(!this.modal&&!document.hidden&&this.querySelector('.wo-hero video')===video){this.heroBlocked=true;this.updateSoundButton();}},{signal:this.abort.signal});
  this.updateSoundButton();this.playHero();
 }
 pauseHero(){const video=this.querySelector('.wo-hero video');if(video){video.muted=true;video.pause();this.updateSoundButton();}}
 refreshHero(){
  const source=this.heroSource(),key=JSON.stringify(source);if(key===this.heroKey)return;
  this.pauseHero();this.heroKey=key;
  const container=this.querySelector('.wo-hero-media');if(container)container.outerHTML=this.media(source.video,source.poster,'wo-hero-active');
  this.setupHero();
 }
 date(){return new Intl.DateTimeFormat(this.lang==='fr'?'fr-FR':'en-GB',{timeZone:'Europe/Paris',weekday:'long',day:'numeric',month:'long',hour:'2-digit',minute:'2-digit',hour12:false}).format(new Date(this.c.dropDate));}
 clock(){return `<p class="wo-date" data-launch-label>${esc(this.date())} <span class="wo-sr">Europe/Paris</span></p><div class="wo-countdown" data-countdown aria-label="${esc(this.date())}">${['days','hours','minutes','seconds'].map(k=>`<div><strong data-${k}>00</strong><span>${this.t(k)}</span></div>`).join('')}</div>`;}
 render(){
  this.clearGallery();
  this.querySelectorAll("video").forEach(v=>{v.muted=true;v.pause();});this.modal=null;
  this.observers?.forEach(o=>o.disconnect());this.observers=[];
  const hero=this.heroSource();this.heroKey=JSON.stringify(hero);
  const c=this.c,logo=c.logo?`<img src="${esc(c.logo)}" alt="WEYZ">`:'<span class="wo-wordmark">WEYZ</span>';
  this.innerHTML=`${c.preview?`<div class="wo-preview-note">${this.t('preview')}</div>`:''}<header class="wo-header"><nav class="wo-lang" aria-label="Language">${['fr','en'].map(l=>`<button data-lang="${l}" aria-current="${this.lang===l}">${l.toUpperCase()}</button>`).join(' / ')}</nav><a class="wo-logo" href="${esc(c.homeURL||'/')}">${logo}</a></header><section class="wo-hero ${c.heroMobile?'has-mobile':''}" style="--hero-fit:${c.heroFit==='contain'?'contain':'cover'};--hero-overlay:${Number(c.overlay)||0};--hero-position:${Number(c.heroPosition)||50}% 50%">${this.media(hero.video,hero.poster,'wo-hero-active')}<div class="wo-hero-shade"></div>${c.heroVideo||c.heroMobile?`<button type="button" class="wo-sound" data-action="sound" aria-label="${this.t('soundOn')}" aria-pressed="false">${this.soundIcon()}</button>`:''}<div class="wo-hero-content">${this.clock()}<a class="wo-button" href="#wo-products">${this.t('discover')}</a><a class="wo-underlink" href="#wo-alert">${this.t('alertOnly')}</a></div></section><main><section class="wo-products" id="wo-products"><h1 class="wo-heading">${this.t('pick')}</h1><p class="wo-subtitle">${this.t('intro')}</p><div class="wo-profile-summary" data-profile></div>${(c.groups||[]).map(g=>this.family(g)).join('')}</section><section class="wo-alert" id="wo-alert"><h2 class="wo-heading">${this.t('miss')}</h2><div class="wo-lookbook" data-lookbook>${(c.lookbook||[]).map(i=>this.image(i,'',this.t('miss'))).join('')}</div><div class="wo-dots" data-lookbook-dots>${(c.lookbook||[]).map((_,i)=>`<button data-lookbook-dot="${i}" aria-label="${i+1}" aria-current="${i===0}"></button>`).join('')}</div><div class="wo-alert-form-wrap">${this.clock()}<h2 class="wo-heading">${this.t('receive')}</h2><div class="wo-alert-tabs" role="tablist" aria-label="${this.t('receive')}"><button role="tab" id="wo-tab-email" aria-selected="true" aria-controls="wo-panel-email" data-tab="email">Email</button><button role="tab" id="wo-tab-wa" aria-selected="false" aria-controls="wo-panel-wa" data-tab="wa">WhatsApp</button></div><div role="tabpanel" id="wo-panel-email" aria-labelledby="wo-tab-email">${c.alertFormHTML||`<form data-form="alert"><label class="wo-sr" for="wo-alert-email">Email</label><input class="wo-input" id="wo-alert-email" type="email" name="email" required autocomplete="email" placeholder="${this.t('email')}"><button class="wo-button">${this.t('subscribe')}</button><p class="wo-form-note">${this.t('alertConsent')}</p><p class="wo-status" role="status"></p></form>`}</div><div role="tabpanel" id="wo-panel-wa" aria-labelledby="wo-tab-wa" hidden>${c.kanalURL?`<a class="wo-button wo-kanal" href="${esc(safeURL(c.kanalURL))}" target="_blank" rel="noopener">${this.t('whatsapp')}</a>`:`<button class="wo-button wo-kanal" disabled>${this.t('whatsapp')}</button>`}</div></div></section></main>${this.footer()}<dialog aria-labelledby="wo-dialog-title"><button class="wo-close" data-action="close" aria-label="${this.t('close')}">×</button><div data-modal-body></div></dialog><div class="wo-toast" role="status" hidden></div>`;
  this.setupHero();this.updateProducts();this.countdown();
  this.centerLookbook(this.lookbookIndex??2);
  const lookbook=this.querySelector('.wo-lookbook');
  let lookbookWidth=lookbook.clientWidth;
  lookbook.addEventListener('scroll',()=>{
   if(lookbook.clientWidth!==lookbookWidth||!lookbook.children.length)return;
   const frame=lookbook.getBoundingClientRect(),center=frame.left+frame.width/2;
   const nearest=[...lookbook.children].map((slide,index)=>{const b=slide.getBoundingClientRect();return {index,distance:Math.abs(b.left+b.width/2-center)};}).sort((a,b)=>a.distance-b.distance)[0];
   this.lookbookIndex=nearest.index;
   this.querySelectorAll('[data-lookbook-dot]').forEach((b,i)=>b.setAttribute('aria-current',String(i===nearest.index)));
  },{signal:this.abort.signal,passive:true});
  const resize=new ResizeObserver(()=>{lookbookWidth=lookbook.clientWidth;this.centerLookbook(this.lookbookIndex??2);});resize.observe(lookbook);this.observers.push(resize);
  this.querySelectorAll('.wo-model-track').forEach(track=>{const observer=new IntersectionObserver(entries=>{const best=entries.filter(e=>e.isIntersecting).sort((a,b)=>b.intersectionRatio-a.intersectionRatio)[0];if(best){const idx=[...track.children].indexOf(best.target),dots=track.parentElement.querySelector('.wo-dots');dots?.querySelectorAll('button').forEach((b,i)=>b.setAttribute('aria-current',String(i===idx)));}},{root:track,threshold:.55});[...track.children].forEach(el=>observer.observe(el));this.observers.push(observer);});
 }
 family(g){const products=this.catalog.filter(p=>p.group===g.key),models=(this.c.models||[]).filter(m=>m.group===g.key);return `<section class="wo-family ${g.accessory?'accessory':''}" data-family="${esc(g.key)}"><h2 class="wo-family-heading">${esc(g.title)}</h2>${!g.accessory?`<p class="wo-colors">${this.t('colors').replace('{n}',products.length)}</p>`:''}<div class="wo-family-content">${models.length?`<div class="wo-model-layout"><div class="wo-model-track">${models.map((m,i)=>`<figure class="wo-model-slide"><div class="wo-measures">${this.t('model')} :<br><span data-measures="${esc(m.id)}">${displayHeight(m.height,this.us)} / ${displayWeight(m.weight,this.us)}</span></div><button class="wo-units" data-action="units" aria-pressed="${this.us}" aria-label="Metric / US"><span class="wo-switch"></span> EUR / US</button><div class="wo-model-stage">${m.image?this.image(m.image,'',g.title):'<div class="wo-model-placeholder">MODEL PHOTO</div>'}${(m.hotspots||[]).map((h,j)=>`<button class="wo-hotspot" style="--x:${Math.max(0,Math.min(100,h.x))}%;--y:${Math.max(0,Math.min(100,h.y))}%" data-model="${esc(m.id)}" data-hotspot="${j}" aria-label="${esc(h.label||g.title)}"><span class="wo-hotspot-dot"></span><span class="wo-hotspot-label">${esc(h.label||'NEW')}</span></button>`).join('')}</div><figcaption class="wo-model-worn">${esc(m.worn||'')}</figcaption></figure>`).join('')}</div>${models.length>1?`<button class="wo-carousel-arrow prev" data-carousel="-1" aria-label="${this.t('previous')}">‹</button><button class="wo-carousel-arrow next" data-carousel="1" aria-label="${this.t('next')}">›</button><div class="wo-dots">${models.map((_,i)=>`<button data-slide="${i}" aria-label="${i+1}" aria-current="${i===0}"></button>`).join('')}</div>`:''}</div>`:''}<div class="wo-product-grid">${products.map(p=>`<article class="wo-product-card" data-product="${esc(p.id)}">${`<button class="wo-product-open" data-product-open="${esc(p.id)}" aria-label="${esc(p.title)}">${this.image(p.image,'wo-product-photo',p.title)}<span class="wo-product-title">${esc(p.title)}</span></button>`}<p class="wo-price" data-price>${this.price(p.variants[0]?.price||0)}</p><div class="wo-product-actions"></div><p class="wo-size-note"></p></article>`).join('')}</div></div></section>`;}
 icon(kind){const paths={truck:'<path d="M2 5h12v12H2zM14 9h4l4 5v3h-8"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>',lock:'<rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3M12 15v2"/>',mail:'<rect x="2" y="5" width="20" height="14" rx="1"/><path d="m2 6 10 8L22 6"/>',Instagram:'<rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><path d="M17 6h1"/>',YouTube:'<rect x="2" y="5" width="20" height="14" rx="4"/><path d="m10 9 5 3-5 3z"/>',X:'<path d="m4 3 16 18h-4L1 3h4m15 0L4 21"/>',Pinterest:'<circle cx="12" cy="12" r="10"/><path d="m9 20 3-13m-1 7c6 5 8-8 2-8-5 0-6 6-3 8"/>'};return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths[kind]||''}</svg>`;}
 footer(){const f=this.c.footer||{};return `<footer class="wo-footer"><div class="wo-footer-inner"><div class="wo-services"><div>${this.icon('truck')}<h2>${esc(f.deliveryEU?(this.lang==='fr'?`Livraison en 2-3 jours en France`:`Delivery in ${f.deliveryEU} days in Europe`):this.t('deliveryTitle'))}</h2><p>${this.t('deliveryHint')}</p></div><div>${this.icon('lock')}<h2>${this.t('paymentTitle')}</h2><p>${this.t('paymentHint')}</p></div><div>${this.icon('mail')}<h2>${this.t('teamTitle')}</h2><p>${this.t('teamHint')} ${f.contactURL?`<a href="${esc(safeURL(f.contactURL,location.href))}">${this.t('contact')}</a>`:''}</p></div></div><div class="wo-footer-bottom"><div class="wo-reviews">${f.reviewsURL?`<a href="${esc(safeURL(f.reviewsURL))}" target="_blank" rel="noopener">${f.reviewsImage?this.image(f.reviewsImage,'wo-reviews-badge',f.reviewsTitle||this.t('review')):esc(f.reviewsTitle||this.t('review'))}</a><p>${esc(f.reviewsText||'')}</p>`:''}</div><div>${this.c.logo?this.image(this.c.logo,'wo-footer-logo','WEYZ'):'<span class="wo-wordmark">WEYZ</span>'}<nav class="wo-socials" aria-label="Social">${(f.socials||[]).filter(s=>s.url).map(s=>`<a aria-label="${esc(s.label)}" href="${esc(safeURL(s.url))}" target="_blank" rel="noopener">${this.icon(s.label)}</a>`).join('')}</nav></div></div><div class="wo-payments">${this.c.paymentsHTML||''}</div>${f.privacyURL?`<a class="wo-footer-legal" href="${esc(f.privacyURL)}">${this.t('privacy')}</a>`:''}</div></footer>`;}
 updateProducts(){
  this.querySelectorAll('[data-product]').forEach(card=>{const p=this.catalog.find(p=>p.id===card.dataset.product);if(!p)return;const size=recommendProduct(this.profile,p);card.querySelector('.wo-product-actions').innerHTML=p.noSizing?'':`<button class="wo-size-label" data-action="sizing">${this.t('yourSize')}</button><span class="wo-size-chip" aria-label="${esc(this.t('suggested'))}">${esc(size||'—')}</span>`;card.querySelector('.wo-size-note').textContent=this.profile&&!size&&!p.noSizing?this.t('noRules'):'';});
  this.querySelector('[data-profile]').innerHTML=this.profile?`<span>${this.t('youAre')}</span><strong class="wo-profile-value">${this.us?displayHeight(this.profile.height,true):Math.round(this.profile.height)+' CM'} & ${displayWeight(this.profile.weight,this.us)}</strong><button class="wo-profile-edit" data-action="sizing">${this.t('modify')}</button><button class="wo-units wo-profile-units" data-action="units" aria-pressed="${this.us}" aria-label="Metric / US"><span class="wo-switch"></span>EUR / US</button>`:`<button class="wo-button wo-size-start" data-action="sizing">${this.t('getSize')}</button>`;
 }
 gallery(p){return p.images?.length?p.images:[p.image||''];}
 galleryLabel(key){const labels={zoom:['Zoom','Zoom'],previous:['Photo précédente','Previous photo'],next:['Photo suivante','Next photo'],loading:['Chargement de la photo…','Loading photo…'],error:['Photo indisponible. Choisis une autre photo.','Photo unavailable. Choose another photo.'],hint:['Glisse pour changer · Double appui pour zoomer','Swipe to browse · Double tap to zoom']};return labels[key][this.lang==='fr'?0:1];}
 thumbnailURL(url){
  try{const u=new URL(safeURL(url,location.href),location.href);if(u.hostname==='cdn.shopify.com'||u.pathname.includes('/cdn/shop/'))u.searchParams.set('width','200');return u.href;}catch{return '';}
 }
 productHTML(){
  const p=this.catalog.find(p=>p.id===this.productId);if(!p)return '';
  const images=this.gallery(p),group=this.c.groups.find(g=>g.key===p.group);this.photoIndex=Math.min(this.photoIndex||0,images.length-1);
  return `<div class="wo-product-detail"><div class="wo-detail-heading"><h2 id="wo-dialog-title">${esc(group?.title||p.title)}</h2><strong>${this.price(p.variants[0]?.price||0)}</strong></div><div class="wo-gallery-main" tabindex="0" role="group" aria-label="${esc(p.title)}">${images.map((url,i)=>url?`<img data-gallery-image="${i}" src="${esc(safeURL(url,location.href))}" alt="${esc(p.title+' — '+(i+1))}" loading="eager" decoding="async" fetchpriority="${i===0?'high':'low'}" draggable="false" ${i!==this.photoIndex?'hidden':''}>`:`<div class="wo-placeholder" data-gallery-image="${i}" ${i!==this.photoIndex?'hidden':''}>WEYZ</div>`).join('')}</div><div class="wo-gallery-tools"><button data-gallery-step="-1" aria-label="${this.galleryLabel('previous')}">‹</button><span data-photo-count aria-live="polite">${this.photoIndex+1} / ${images.length}</span><button data-gallery-step="1" aria-label="${this.galleryLabel('next')}">›</button><button data-gallery-zoom aria-label="${this.galleryLabel('zoom')}" aria-pressed="false">＋</button></div><p class="wo-gallery-hint">${this.galleryLabel('hint')}</p><p class="wo-gallery-status" role="status" aria-live="polite"></p><div class="wo-thumbnails" aria-label="${esc(p.title)}">${images.map((url,i)=>`<button data-photo="${i}" aria-label="${i+1}" aria-pressed="${i===this.photoIndex}">${this.image(url?this.thumbnailURL(url):'','',p.title+' — '+(i+1))}</button>`).join('')}</div></div>`;
 }
 clearGallery(){this.galleryAbort?.abort();this.galleryResize?.disconnect();this.galleryRequest=(this.galleryRequest||0)+1;}
 setupGallery(){
  this.clearGallery();this.galleryAbort=new AbortController();const signal=this.galleryAbort.signal;
  const frame=this.querySelector('.wo-gallery-main');if(!frame)return;
  this.photoZoom={scale:1,x:0,y:0};this.requestedPhoto=this.photoIndex;this.updateGalleryControls();
  // Keep all photos mounted and decode them ahead of navigation, instead of rebuilding the dialog.
  frame.querySelectorAll('img').forEach(img=>{img.decode().then(()=>{img.dataset.decoded='true';}).catch(()=>{if(frame.isConnected&&this.modal==='product'&&Number(img.dataset.galleryImage)===this.photoIndex)this.querySelector('.wo-gallery-status').textContent=this.galleryLabel('error');});});
  this.querySelectorAll('.wo-thumbnails img').forEach(img=>{
   const failed=()=>{const placeholder=document.createElement('span');placeholder.className='wo-thumb-failed';placeholder.textContent='×';placeholder.setAttribute('aria-hidden','true');img.replaceWith(placeholder);};
   img.addEventListener('error',failed,{signal,once:true});if(img.complete&&!img.naturalWidth)failed();
  });
  const point=(x,y)=>{const b=frame.getBoundingClientRect();return {x:x-b.left-b.width/2,y:y-b.top-b.height/2};};
  let touch=null,lastTap=null,mouse=null;
  const pinchStart=ts=>{const a=ts[0],b=ts[1];return {mode:'pinch',distance:Math.max(1,Math.hypot(a.clientX-b.clientX,a.clientY-b.clientY)),point:point((a.clientX+b.clientX)/2,(a.clientY+b.clientY)/2),zoom:{...this.photoZoom}};};
  frame.addEventListener('touchstart',e=>{
   if(e.touches.length>=2){e.preventDefault();touch=pinchStart(e.touches);lastTap=null;}
   else{const t=e.touches[0];touch={mode:this.photoZoom.scale>1?'pan':'swipe',x:t.clientX,y:t.clientY,dx:0,dy:0,zoom:{...this.photoZoom}};}
  },{signal,passive:false});
  frame.addEventListener('touchmove',e=>{
   if(!touch)return;
   if(e.touches.length>=2){
    e.preventDefault();if(touch.mode!=='pinch')touch=pinchStart(e.touches);
    const a=e.touches[0],b=e.touches[1],scale=Math.max(1,Math.min(4,touch.zoom.scale*Math.hypot(a.clientX-b.clientX,a.clientY-b.clientY)/touch.distance)),mid=point((a.clientX+b.clientX)/2,(a.clientY+b.clientY)/2),ratio=scale/touch.zoom.scale;
    this.photoZoom={scale,x:mid.x-(touch.point.x-touch.zoom.x)*ratio,y:mid.y-(touch.point.y-touch.zoom.y)*ratio};this.applyPhotoZoom();return;
   }
   const t=e.touches[0];touch.dx=t.clientX-touch.x;touch.dy=t.clientY-touch.y;
   if(touch.mode==='pan'){e.preventDefault();this.photoZoom={...touch.zoom,x:touch.zoom.x+touch.dx,y:touch.zoom.y+touch.dy};this.applyPhotoZoom();}
   else if(touch.mode==='swipe'&&Math.abs(touch.dx)>Math.abs(touch.dy)&&Math.abs(touch.dx)>8)e.preventDefault();
  },{signal,passive:false});
  frame.addEventListener('touchend',e=>{
   this.lastGalleryTouch=Date.now();if(!touch)return;
   if(e.touches.length){const t=e.touches[0];touch={mode:'pan',x:t.clientX,y:t.clientY,dx:0,dy:0,zoom:{...this.photoZoom},fromPinch:true};return;}
   const g=touch;touch=null;
   if(g.mode==='swipe'&&Math.abs(g.dx)>35&&Math.abs(g.dx)>Math.abs(g.dy)*1.2){e.preventDefault();lastTap=null;this.selectPhoto(this.requestedPhoto+(g.dx<0?1:-1));return;}
   if(g.mode==='pinch'||g.fromPinch||Math.hypot(g.dx||0,g.dy||0)>10){lastTap=null;return;}
   const t=e.changedTouches[0],now=Date.now();
   if(lastTap&&now-lastTap.time<320&&Math.hypot(t.clientX-lastTap.x,t.clientY-lastTap.y)<30){e.preventDefault();this.togglePhotoZoom(point(t.clientX,t.clientY));lastTap=null;}
   else lastTap={time:now,x:t.clientX,y:t.clientY};
  },{signal,passive:false});
  frame.addEventListener('touchcancel',()=>{touch=null;lastTap=null;},{signal});
  frame.addEventListener('pointerdown',e=>{if(e.pointerType==='touch'||e.button!==0)return;mouse={x:e.clientX,y:e.clientY,zoom:{...this.photoZoom}};frame.setPointerCapture(e.pointerId);},{signal});
  frame.addEventListener('pointermove',e=>{if(!mouse||mouse.zoom.scale<=1)return;this.photoZoom={...mouse.zoom,x:mouse.zoom.x+e.clientX-mouse.x,y:mouse.zoom.y+e.clientY-mouse.y};this.applyPhotoZoom();},{signal});
  frame.addEventListener('pointerup',e=>{if(!mouse)return;const dx=e.clientX-mouse.x,dy=e.clientY-mouse.y;if(mouse.zoom.scale===1&&Math.abs(dx)>35&&Math.abs(dx)>Math.abs(dy)*1.2)this.selectPhoto(this.requestedPhoto+(dx<0?1:-1));mouse=null;},{signal});
  frame.addEventListener('pointercancel',()=>{mouse=null;},{signal});
  frame.addEventListener('dblclick',e=>{if(Date.now()-(this.lastGalleryTouch||0)<500)return;e.preventDefault();this.togglePhotoZoom(point(e.clientX,e.clientY));},{signal});
  frame.addEventListener('keydown',e=>{
   if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.selectPhoto(this.requestedPhoto+(e.key==='ArrowRight'?1:-1));}
   if(e.key==='+'||e.key==='='||e.key==='-'){e.preventDefault();this.setPhotoZoom(this.photoZoom.scale+(e.key==='-'?-.5:.5));}
  },{signal});
  this.galleryResize=new ResizeObserver(()=>this.applyPhotoZoom());this.galleryResize.observe(frame);
 }
 setPhotoZoom(scale,point={x:0,y:0}){const z=this.photoZoom||{scale:1,x:0,y:0};scale=Math.max(1,Math.min(4,scale));const ratio=scale/z.scale;this.photoZoom={scale,x:point.x-(point.x-z.x)*ratio,y:point.y-(point.y-z.y)*ratio};this.applyPhotoZoom();}
 togglePhotoZoom(point){this.setPhotoZoom(this.photoZoom.scale>1?1:2.5,point);}
 applyPhotoZoom(){
  const frame=this.querySelector('.wo-gallery-main'),img=frame?.querySelector(`[data-gallery-image="${this.photoIndex}"]`),z=this.photoZoom;if(!img||!z)return;
  if(img.tagName!=='IMG'){z.scale=1;z.x=z.y=0;}
  const width=frame.clientWidth,height=frame.clientHeight,ratio=img.naturalWidth&&img.naturalHeight?img.naturalWidth/img.naturalHeight:width/height;
  const fitWidth=Math.min(width,height*ratio),fitHeight=fitWidth/ratio,maxX=Math.max(0,(fitWidth*z.scale-width)/2),maxY=Math.max(0,(fitHeight*z.scale-height)/2);
  z.x=Math.max(-maxX,Math.min(maxX,z.x));z.y=Math.max(-maxY,Math.min(maxY,z.y));
  img.style.transform=`translate(${z.x}px,${z.y}px) scale(${z.scale})`;frame.classList.toggle('is-zoomed',z.scale>1);this.updateGalleryControls();
 }
 updateGalleryControls(){
  const frame=this.querySelector('.wo-gallery-main');if(!frame)return;const count=frame.children.length;
  this.querySelector('[data-photo-count]').textContent=`${this.photoIndex+1} / ${count}`;
  this.querySelector('[data-gallery-step="-1"]').disabled=this.requestedPhoto<=0;
  this.querySelector('[data-gallery-step="1"]').disabled=this.requestedPhoto>=count-1;
  const zoom=this.querySelector('[data-gallery-zoom]'),active=frame.children[this.photoIndex];zoom.disabled=active?.tagName!=='IMG';zoom.textContent=this.photoZoom?.scale>1?'−':'＋';zoom.setAttribute('aria-pressed',String(this.photoZoom?.scale>1));
 }
 selectPhoto(index){
  const frame=this.querySelector('.wo-gallery-main');if(!frame)return;index=Math.max(0,Math.min(frame.children.length-1,index));this.requestedPhoto=index;this.updateGalleryControls();
  const token=++this.galleryRequest,img=frame.children[index],status=this.querySelector('.wo-gallery-status');
  const finish=()=>{
   if(token!==this.galleryRequest||this.modal!=='product'||!frame.isConnected)return;
   frame.querySelectorAll('[data-gallery-image]').forEach((el,i)=>{el.hidden=i!==index;el.style.transform='';});
   this.photoIndex=index;this.photoZoom={scale:1,x:0,y:0};this.applyPhotoZoom();frame.removeAttribute('aria-busy');status.textContent='';
   this.querySelectorAll('[data-photo]').forEach(el=>el.setAttribute('aria-pressed',String(Number(el.dataset.photo)===index)));
   const thumb=this.querySelector(`[data-photo="${index}"]`),track=thumb?.parentElement;
   if(track){const left=thumb.offsetLeft-track.offsetLeft-(track.clientWidth-thumb.clientWidth)/2;track.scrollTo({left,behavior:'instant'});}
  };
  if(img.tagName!=='IMG'||(img.complete&&img.naturalWidth&&img.dataset.decoded==='true')){finish();return;}
  frame.setAttribute('aria-busy','true');status.textContent=this.galleryLabel('loading');img.fetchPriority='high';
  img.decode().then(()=>{img.dataset.decoded='true';finish();}).catch(()=>{if(token!==this.galleryRequest||!frame.isConnected)return;frame.removeAttribute('aria-busy');status.textContent=this.galleryLabel('error');this.requestedPhoto=this.photoIndex;this.updateGalleryControls();});
 }
 countdown(){const live=Date.now()>=new Date(this.c.dropDate).getTime();if(live){this.querySelectorAll('[data-launch-label]').forEach(el=>el.textContent=this.t('live'));}this.isLive=live;let secs=Math.max(0,Math.floor((new Date(this.c.dropDate)-Date.now())/1000));const v={days:Math.floor(secs/86400),hours:Math.floor(secs/3600)%24,minutes:Math.floor(secs/60)%60,seconds:secs%60};this.querySelectorAll('[data-countdown]').forEach(el=>Object.entries(v).forEach(([k,n])=>el.querySelector(`[data-${k}]`).textContent=String(n).padStart(2,'0')));}
 open(kind){this.modal=kind;this.pauseHero();const d=this.querySelector('dialog');d.classList.toggle('wo-video-dialog',kind==='video');this.renderModal();if(!d.open)d.showModal();if(kind==='product')this.setupGallery();const video=d.querySelector('video');if(video)video.play()?.catch(()=>{if(d.open&&this.modal==='video'){video.muted=true;video.play()?.catch(()=>{});}});}
 close(){const d=this.querySelector('dialog'),video=d.querySelector('video');if(video){video.muted=true;video.pause();}d.close();}
 renderModal(){this.clearGallery();const body=this.querySelector('[data-modal-body]');if(this.modal==='product')body.innerHTML=this.productHTML();if(this.modal==='sizing'){this.draft={height:this.profile?.height||174,weight:this.profile?.weight||68,fit:this.profile?.fit||'regular',heightUS:this.us,weightUS:this.us};body.innerHTML=this.sizingHTML();}if(this.modal==='video')body.innerHTML=`<div class="wo-video-body"><h2 id="wo-dialog-title" class="wo-sr">${esc(this.videoTitle||'Video')}</h2>${this.videoURL?`<video autoplay loop playsinline disablepictureinpicture disableremoteplayback preload="metadata" src="${esc(this.videoURL)}"></video>`:`<p class="wo-video-missing">${this.t('videoMissing')}</p>`}</div>`;}
 sizingHTML(){const d=this.draft;return `<div class="wo-modal-body wo-sizing"><form data-form="sizing"><h1 id="wo-dialog-title" class="wo-sr">${this.t('pickSize')}</h1><div class="wo-measure-block"><h2>${this.t('height')}</h2><p class="wo-hint">${this.t('heightHint')}</p><div data-height-controls>${this.heightControls()}</div><div class="wo-unit-picker"><button type="button" data-unit="height" aria-pressed="${!d.heightUS}">CM</button><span>/</span><button type="button" data-unit="height" aria-pressed="${d.heightUS}">FT / IN</button></div></div><div class="wo-measure-block"><h2>${this.t('weight')}</h2><p class="wo-hint">${this.t('weightHint')}</p><div data-weight-controls>${this.weightControls()}</div><div class="wo-unit-picker"><button type="button" data-unit="weight" aria-pressed="${!d.weightUS}">KG</button><span>/</span><button type="button" data-unit="weight" aria-pressed="${d.weightUS}">LBS</button></div></div><h2>${this.t('fit')}</h2><p class="wo-hint">${this.t('fitHint')}</p><div class="wo-fit-options">${['regular','oversize'].map(f=>`<label class="wo-fit-choice"><input type="radio" name="fit" value="${f}" ${d.fit===f?'checked':''}><span>${this.t(f).toUpperCase()}${f==='regular'?`<small>${this.t('regularHint')}</small>`:''}</span></label>`).join('')}</div><button class="wo-button">${this.t('enter')}</button><p class="wo-status" role="status"></p></form></div>`;}
 heightControls(){const d=this.draft;if(d.heightUS){const inches=Math.round(d.height/2.54);return `<div class="wo-ft-inputs"><label>ft<input aria-label="Feet" type="number" name="feet" min="3" max="8" value="${Math.floor(inches/12)}" required></label><label>in<input aria-label="Inches" type="number" name="inches" min="0" max="11" value="${inches%12}" required></label></div>`;}return this.wheel('height',Math.round(d.height),100,240);}
 weightControls(){return this.wheel('weight',Math.round(this.draft.weight*(this.draft.weightUS?2.2046226218:1)),this.draft.weightUS?44:20,this.draft.weightUS?661:300);}
 wheel(field,v,min,max){return `<div class="wo-wheel"><button type="button" data-step="${field}" data-delta="-1" aria-label="−">‹</button><span class="wo-adjacent">${v-1}</span><input aria-label="${this.t(field)}" type="number" inputmode="numeric" name="${field}" min="${min}" max="${max}" step="1" value="${v}" required><span class="wo-adjacent">${v+1}</span><button type="button" data-step="${field}" data-delta="1" aria-label="+">›</button></div>`;}
 syncDraft(){const b=this.querySelector('[data-modal-body]'),d=this.draft;const enteredHeight=d.heightUS?Number(b.querySelector('[name=feet]').value)*12+Number(b.querySelector('[name=inches]').value):Number(b.querySelector('[name=height]').value);const shownHeight=Math.round(d.height/(d.heightUS?2.54:1));if(enteredHeight!==shownHeight)d.height=enteredHeight*(d.heightUS?2.54:1);const enteredWeight=Number(b.querySelector('[name=weight]').value),factor=d.weightUS?2.2046226218:1;if(enteredWeight!==Math.round(d.weight*factor))d.weight=enteredWeight/factor;d.fit=b.querySelector('[name=fit]:checked')?.value||'regular';}
 setStatus(form,message,error=false){const el=form?.querySelector('.wo-status')||this.querySelector('[data-cart-status]');if(el){el.textContent=message;el.classList.toggle('is-error',error);}}
 toast(message){const el=this.querySelector('.wo-toast');el.textContent=message;el.hidden=false;clearTimeout(this.toastTimer);this.toastTimer=setTimeout(()=>el.hidden=true,3000);}
 bind(){const opts={signal:this.abort.signal};this.heroQuery.addEventListener('change',()=>this.refreshHero(),opts);document.addEventListener('visibilitychange',()=>{if(document.hidden){this.querySelectorAll('video').forEach(v=>{v.muted=true;v.pause();});}else if(this.modal==='video'){this.querySelector('dialog video')?.play()?.catch(()=>{});}else this.playHero();},opts);this.addEventListener('click',async e=>{const b=e.target.closest('button');if(!b)return;
  if(b.dataset.lang){const form=document.getElementById(this.c.localizationForm);if(form){form.querySelector('[name=language_code]').value=b.dataset.lang;form.requestSubmit();}else{this.lang=b.dataset.lang;this.render();}return;}
  if(b.dataset.action==='close'){this.close();return;}
  if(b.dataset.action==='sizing'){this.open(b.dataset.action);return;}
  if(b.dataset.action==='sound'){const video=this.querySelector('.wo-hero video');if(video){video.muted=this.heroBlocked||video.paused?false:!video.muted;this.updateSoundButton();this.playHero();}return;}
  if(b.dataset.action==='units'){this.us=!this.us;this.querySelectorAll('[data-measures]').forEach(el=>{const m=this.c.models.find(m=>m.id===el.dataset.measures);el.textContent=`${displayHeight(m.height,this.us)} / ${displayWeight(m.weight,this.us)}`;});this.querySelectorAll('.wo-units').forEach(el=>el.setAttribute('aria-pressed',String(this.us)));this.updateProducts();return;}
  if(b.dataset.productOpen){this.productId=b.dataset.productOpen;this.photoIndex=0;this.open('product');return;}
  if(b.dataset.photo!==undefined){this.selectPhoto(Number(b.dataset.photo));return;}
  if(b.dataset.galleryStep){this.selectPhoto(this.requestedPhoto+Number(b.dataset.galleryStep));return;}
  if(b.hasAttribute('data-gallery-zoom')){this.togglePhotoZoom();return;}
  if(b.dataset.hotspot!==undefined){const m=this.c.models.find(m=>m.id===b.dataset.model),h=m?.hotspots[Number(b.dataset.hotspot)];this.videoURL=h?.video||'';this.videoTitle=h?.label||'Video';this.open('video');return;}
  if(b.dataset.carousel||b.dataset.slide!==undefined){const wrap=b.closest('.wo-model-layout'),track=wrap.querySelector('.wo-model-track');track.scrollTo({left:b.dataset.slide!==undefined?Number(b.dataset.slide)*track.clientWidth:track.scrollLeft+Number(b.dataset.carousel)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});return;}
  if(b.dataset.lookbookDot!==undefined){this.centerLookbook(Number(b.dataset.lookbookDot),matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth');return;}
  if(b.dataset.tab){this.querySelectorAll('[data-tab]').forEach(t=>t.setAttribute('aria-selected',String(t===b)));this.querySelector('#wo-panel-email').hidden=b.dataset.tab!=='email';this.querySelector('#wo-panel-wa').hidden=b.dataset.tab!=='wa';return;}
  if(b.dataset.unit){if(b.getAttribute('aria-pressed')==='true')return;this.syncDraft();this.draft[b.dataset.unit+'US']=!this.draft[b.dataset.unit+'US'];this.querySelector('[data-modal-body]').innerHTML=this.sizingHTML();return;}
  if(b.dataset.step){const el=this.querySelector(`[name=${b.dataset.step}]`);el.value=Math.max(Number(el.min),Math.min(Number(el.max),Number(el.value)+Number(b.dataset.delta)));this.syncDraft();this.querySelector(`[data-${b.dataset.step}-controls]`).innerHTML=b.dataset.step==='height'?this.heightControls():this.weightControls();}
 },opts);
 this.addEventListener('submit',async e=>{const form=e.target.closest('[data-form]');if(!form)return;e.preventDefault();if(form.dataset.form==='sizing'){this.syncDraft();if(!Number.isFinite(this.draft.height)||!Number.isFinite(this.draft.weight)||this.draft.height<100||this.draft.height>240||this.draft.weight<20||this.draft.weight>300){this.setStatus(form,this.t('invalid'),true);return;}this.profile={height:this.draft.height,weight:this.draft.weight,fit:this.draft.fit};this.close();this.updateProducts();return;}
 if(form.dataset.form==='alert'){this.setStatus(form,this.t('previewSent'));}},opts);
 this.addEventListener('close',e=>{if(e.target.tagName==='DIALOG'&&!e.target.open){this.clearGallery();const video=e.target.querySelector('video');if(video){video.muted=true;video.pause();}this.modal=null;this.playHero();}},{...opts,capture:true});
 }
}
if(!customElements.get('weyz-october'))customElements.define('weyz-october',WeyzOctober);

})();/* WEYZ media polish — safe to append after the existing storefront script. */
(() => {
 customElements.whenDefined('weyz-october').then(() => {
  const proto=customElements.get('weyz-october').prototype;
  if(proto.weyzMediaPolish)return;
  proto.weyzMediaPolish=true;
  const render=proto.render,renderModal=proto.renderModal,setupGallery=proto.setupGallery;
  function warmCards(host){
   host.mediaWarmObserver?.disconnect();
   host.mediaWarmAbort?.abort();
   host.mediaWarmAbort=new AbortController();
   const signal=host.mediaWarmAbort.signal;
   host.abort?.signal.addEventListener('abort',()=>{host.mediaWarmObserver?.disconnect();host.mediaWarmAbort.abort();},{once:true,signal});
   host.mediaWarmCache ||= new Map();
   const warm=(card,count)=>{
    const p=host.catalog.find(p=>String(p.id)===card.dataset.productOpen);if(!p)return;
    host.gallery(p).slice(0,count).forEach(raw=>{
     if(!raw)return;
     let url;try{url=new URL(raw,location.href);if(!['https:','http:'].includes(url.protocol))return;}catch{return;}
     if(host.mediaWarmCache.has(url.href)||host.mediaWarmCache.size>=30)return;
     const img=new Image();img.decoding='async';img.fetchPriority='low';
     host.mediaWarmCache.set(url.href,img);img.src=url.href;img.decode().catch(()=>{});
    });
   };
   host.mediaWarmObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(entry.isIntersecting){warm(entry.target,1);host.mediaWarmObserver.unobserve(entry.target);}
   }),{rootMargin:'180px'});
   host.querySelectorAll('[data-product-open]').forEach(card=>host.mediaWarmObserver.observe(card));
   for(const event of ['pointerover','focusin','touchstart'])host.addEventListener(event,e=>{
    const card=e.target.closest('[data-product-open]');if(card)warm(card,3);
   },{signal,passive:true});
  }
  proto.render=function(...args){const result=render.apply(this,args);warmCards(this);return result;};
  proto.renderModal=function(...args){
   const result=renderModal.apply(this,args),dialog=this.querySelector('dialog'),video=dialog?.querySelector('video');
   dialog?.style.removeProperty('--wo-video-ratio');
   if(video){
    const size=()=>{if(video.videoWidth&&video.videoHeight)dialog.style.setProperty('--wo-video-ratio',String(video.videoWidth/video.videoHeight));};
    video.addEventListener('loadedmetadata',size,{once:true});size();
   }
   return result;
  };
  proto.setupGallery=function(...args){
   const result=setupGallery.apply(this,args);
   this.querySelectorAll('.wo-gallery-main img').forEach(img=>img.decode().catch(()=>{img.dataset.failed='true';}));
   this.querySelectorAll('.wo-thumbnails img').forEach(img=>{
    img.loading='eager';img.decoding='async';
    img.decode().then(()=>{img.dataset.ready='true';}).catch(()=>{});
   });
   return result;
  };
  document.querySelectorAll('weyz-october').forEach(host=>{if(host.catalog)warmCards(host);});
 });
})();

/* WEYZ mobile controls — append after the existing storefront script. */
(() => {
 customElements.whenDefined('weyz-october').then(() => {
  const proto=customElements.get('weyz-october').prototype;
  if(proto.weyzMobileControls)return;
  proto.weyzMobileControls=true;
  const render=proto.render,updateSoundButton=proto.updateSoundButton;
  proto.updateSoundButton=function(){
   const video=this.querySelector('.wo-hero video');
   // Also guard the initial play started by the older script before this add-on loaded.
   if(this.woConfirmedSound&&video&&!video.paused&&this.heroBlocked){video.muted=false;this.heroBlocked=false;}
   if(video?.muted&&!this.heroBlocked)this.woConfirmedSound=false;
   return updateSoundButton.call(this);
  };
  // An older autoplay rejection must not undo a later successful user tap.
  proto.playHero=function(){
   const video=this.querySelector('.wo-hero video');if(!video||this.modal||document.hidden)return;
   const request=this.heroPlayRequest=(this.heroPlayRequest||0)+1;
   const failed=()=>{
    if(request!==this.heroPlayRequest||!this.isConnected||this.modal||document.hidden||this.querySelector('.wo-hero video')!==video)return;
    this.woConfirmedSound=false;video.muted=true;this.heroBlocked=true;this.updateSoundButton();
   };
   try{video.play()?.then(()=>{if(request===this.heroPlayRequest&&!this.modal)this.woConfirmedSound=!video.muted&&!video.paused;}).catch(failed);}catch{failed();}
  };
  function install(host){
   host.mobileControlsAbort?.abort();host.mobileControlsAbort=new AbortController();
   const signal=host.mobileControlsAbort.signal;
   host.abort?.signal.addEventListener('abort',()=>host.mobileControlsAbort.abort(),{signal,once:true});
   host.classList.toggle('wo-pointer-ui',matchMedia('(pointer:coarse)').matches);
   host.addEventListener('pointerdown',()=>host.classList.add('wo-pointer-ui'),{signal,capture:true});
   document.addEventListener('keydown',e=>{if(e.key==='Tab')host.classList.remove('wo-pointer-ui');},{signal,capture:true});
   const sound=e=>e.target.closest?.('[data-action="sound"]');
   let gesture=null,lastTap=0;
   host.addEventListener('touchstart',e=>{
    if(!sound(e)||e.touches.length!==1){gesture=null;return;}
    gesture={x:e.touches[0].clientX,y:e.touches[0].clientY,moved:false};
   },{signal,capture:true,passive:true});
   host.addEventListener('touchmove',e=>{
    if(gesture&&(e.touches.length!==1||Math.hypot(e.touches[0].clientX-gesture.x,e.touches[0].clientY-gesture.y)>12))gesture.moved=true;
   },{signal,capture:true,passive:true});
   host.addEventListener('touchcancel',()=>{gesture=null;},{signal,capture:true});
   host.addEventListener('touchend',e=>{
    const tap=gesture;gesture=null;if(!tap||tap.moved||!sound(e)||host.modal)return;
    const video=host.querySelector('.wo-hero video');if(!video)return;
    // Keep unmute/play inside the original touch gesture for iOS.
    e.preventDefault();e.stopPropagation();lastTap=Date.now();
    video.muted=host.heroBlocked||video.paused?false:!video.muted;
    host.updateSoundButton();host.playHero();
   },{signal,capture:true,passive:false});
   host.addEventListener('click',e=>{
    if(sound(e)&&Date.now()-lastTap<700){e.preventDefault();e.stopImmediatePropagation();}
   },{signal,capture:true});
  }
  proto.render=function(...args){const result=render.apply(this,args);install(this);return result;};
  document.querySelectorAll('weyz-october').forEach(host=>{if(host.catalog)install(host);});
 });
})();

/* WEYZ sizing swipe â€” JAVASCRIPT: append only to weyz-october.js. */
(() => {
 customElements.whenDefined('weyz-october').then(() => {
  const proto=customElements.get('weyz-october').prototype;
  if(proto.weyzSizingSwipe)return;
  proto.weyzSizingSwipe=true;
  // Styles are included here so this correction needs only one JavaScript paste.
  if(!document.getElementById('wo-sizing-swipe-style')){
   const style=document.createElement('style');style.id='wo-sizing-swipe-style';
   style.textContent='.wo-sizing .wo-wheel{touch-action:pan-y;user-select:none;-webkit-user-select:none;cursor:ew-resize}.wo-sizing .wo-wheel input{touch-action:pan-y;user-select:text;-webkit-user-select:text;cursor:text}.wo-sizing .wo-wheel.is-swiping,.wo-sizing .wo-wheel.is-swiping input{cursor:grabbing}';
   document.head.append(style);
  }
  const render=proto.render;
  function install(host){
   host.sizingSwipeAbort?.abort();host.sizingSwipeAbort=new AbortController();
   const signal=host.sizingSwipeAbort.signal;
   host.abort?.signal.addEventListener('abort',()=>host.sizingSwipeAbort.abort(),{signal,once:true});
   let gesture=null,suppressUntil=0;
   const stop=()=>{gesture?.wheel.classList.remove('is-swiping');gesture=null;};
   const start=(target,x,y)=>{
    stop();if(host.modal!=='sizing'||target.closest('button'))return;
    const wheel=target.closest('.wo-sizing .wo-wheel'),input=wheel?.querySelector('input');if(!input)return;
    gesture={wheel,input,x,y,mode:null,base:Number(input.value),changed:false};
   };
   const move=(x,y,event)=>{
    const g=gesture;if(!g)return;
    if(!g.wheel.isConnected||host.modal!=='sizing'){stop();return;}
    const dx=x-g.x,dy=y-g.y;
    if(!g.mode&&Math.max(Math.abs(dx),Math.abs(dy))>=10)g.mode=Math.abs(dx)>Math.abs(dy)*1.2?'horizontal':'vertical';
    if(g.mode!=='horizontal')return;
    event.preventDefault();g.wheel.classList.add('is-swiping');
    // One unit per 24 CSS pixels; dragging left brings the larger value into the centre.
    const min=Number(g.input.min),max=Number(g.input.max),base=Number.isFinite(g.base)?g.base:min;
    const value=Math.max(min,Math.min(max,base+Math.round(-dx/24)));
    g.input.value=String(value);
    const adjacent=g.wheel.querySelectorAll('.wo-adjacent');
    if(adjacent[0])adjacent[0].textContent=String(value-1);
    if(adjacent[1])adjacent[1].textContent=String(value+1);
    host.syncDraft();g.changed=true;
   };
   const end=event=>{
    if(gesture?.mode==='horizontal'){event.preventDefault();suppressUntil=Date.now()+500;}
    stop();
   };
   host.addEventListener('touchstart',e=>{
    if(e.touches.length!==1){stop();return;}
    start(e.target,e.touches[0].clientX,e.touches[0].clientY);
   },{signal,passive:true});
   host.addEventListener('touchmove',e=>{
    if(e.touches.length!==1){stop();return;}
    move(e.touches[0].clientX,e.touches[0].clientY,e);
   },{signal,passive:false});
   host.addEventListener('touchend',end,{signal,passive:false});
   host.addEventListener('touchcancel',stop,{signal});
   host.addEventListener('pointerdown',e=>{
    if(e.pointerType==='touch'||e.button!==0)return;
    start(e.target,e.clientX,e.clientY);
   },{signal});
   window.addEventListener('pointermove',e=>{if(e.pointerType!=='touch')move(e.clientX,e.clientY,e);},{signal});
   window.addEventListener('pointerup',e=>{if(e.pointerType!=='touch')end(e);},{signal});
   window.addEventListener('pointercancel',e=>{if(e.pointerType!=='touch')stop();},{signal});
   host.addEventListener('click',e=>{
    if(Date.now()<suppressUntil&&e.target.closest('.wo-sizing .wo-wheel')&&!e.target.closest('button')){e.preventDefault();e.stopImmediatePropagation();}
   },{signal,capture:true});
   // Keep neighbours in sync when the value is typed directly.
   host.addEventListener('input',e=>{
    const input=e.target,wheel=input.closest('.wo-sizing .wo-wheel');
    if(!wheel||input.tagName!=='INPUT'||input.value===''||!input.validity.valid)return;
    const neighbours=wheel.querySelectorAll('.wo-adjacent'),n=Number(input.value);
    if(neighbours[0])neighbours[0].textContent=String(n-1);
    if(neighbours[1])neighbours[1].textContent=String(n+1);
   },{signal});
  }
  proto.render=function(...args){const result=render.apply(this,args);install(this);return result;};
  document.querySelectorAll('weyz-october').forEach(host=>{if(host.catalog)install(host);});
 });
})();

/* WEYZ sizing sliders — JAVASCRIPT ONLY; append to weyz-october.js. */
(() => {
 customElements.whenDefined('weyz-october').then(()=>{
  const proto=customElements.get('weyz-october').prototype;
  if(proto.weyzSizingSliders)return;proto.weyzSizingSliders=true;
  const style=document.createElement('style');style.id='wo-sizing-sliders-style';
  style.textContent=`
  .wo-sizing .wo-value-wheel{display:grid;grid-template-columns:34px minmax(0,1fr) 34px;width:82%;max-width:420px;margin:18px auto 12px;gap:0}
  .wo-sizing .wo-value-arrow{padding:0;min-width:34px;min-height:44px;font-size:24px}
  .wo-sizing .wo-value-track{position:relative;height:clamp(44px,12.21vw,74.8px);overflow:hidden;touch-action:pan-y;user-select:none;-webkit-user-select:none;cursor:ew-resize}
  .wo-sizing .wo-value-cell{position:absolute;left:30%;top:0;width:40%;height:100%;display:flex;align-items:center;justify-content:center;white-space:nowrap;font-size:clamp(40px,11.1vw,68px);line-height:1.1;color:#ccc;pointer-events:none;will-change:transform;transform-origin:center}
  .wo-sizing .wo-value-editor{position:absolute;left:30%;top:0;width:40%;height:100%;display:flex;align-items:center;justify-content:center;gap:4px}
  .wo-sizing .wo-value-editor input{width:100%;min-width:0;padding:0;text-align:center;font-size:clamp(40px,11.1vw,68px);font-weight:400;line-height:1.1;border:0;background:transparent;color:#000;appearance:textfield;touch-action:pan-y}
  .wo-sizing .wo-value-editor input::-webkit-inner-spin-button{appearance:none}
  .wo-sizing .wo-value-track.is-dragging .wo-value-editor,.wo-sizing .wo-value-track.is-settling .wo-value-editor{visibility:hidden}
  .wo-sizing .wo-value-track:not(.is-dragging):not(.is-settling) .wo-value-cell[data-offset="0"]{visibility:hidden}
  .wo-sizing .wo-value-track.is-settling .wo-value-cell{transition:transform 160ms ease-out,color 160ms ease-out}
  .wo-sizing .wo-value-wheel.is-feet .wo-value-cell{font-size:clamp(16px,4.8vw,27px)}
  .wo-sizing .wo-value-wheel.is-feet .wo-value-cell[data-offset="0"]{font-size:clamp(25px,7vw,40px);color:#000}
  .wo-sizing .wo-value-wheel.is-feet .wo-value-editor{gap:8px}
  .wo-sizing .wo-value-wheel.is-feet .wo-value-editor label{width:50%;min-width:0;display:flex;flex-direction:column;align-items:center}
  .wo-sizing .wo-value-wheel.is-feet .wo-value-editor input{font-size:clamp(25px,7vw,40px)}
  .wo-sizing .wo-value-editor small{font-size:10px;line-height:1;color:#777}
  weyz-october .wo-sizing .wo-unit-switch{position:relative;flex:0 0 44px;width:44px;height:44px;padding:0!important;min-height:44px;margin-left:3px;touch-action:pan-y}
  .wo-unit-switch::before{content:"";position:absolute;left:5px;top:14px;width:34px;height:17px;border-radius:20px;background:#222}
  .wo-unit-switch::after{content:"";position:absolute;left:7px;top:16px;width:13px;height:13px;border-radius:50%;background:#fff;transition:transform 160ms ease}
  .wo-unit-switch[aria-checked="true"]::after{transform:translateX(17px)}
  @media(max-width:380px){.wo-sizing .wo-value-wheel{width:92%}}
  @media(prefers-reduced-motion:reduce){.wo-unit-switch::after,.wo-sizing .wo-value-track.is-settling .wo-value-cell{transition:none}}
  `;document.head.append(style);
  const renderModal=proto.renderModal,clearGallery=proto.clearGallery;
  function setup(host){
   host.valueSliderAbort?.abort();host.valueSliderResize?.disconnect();
   if(host.modal!=='sizing')return;
   host.valueSliderAbort=new AbortController();const signal=host.valueSliderAbort.signal;
   host.abort?.signal.addEventListener('abort',()=>{host.valueSliderAbort.abort();host.valueSliderResize?.disconnect();},{signal,once:true});
   const body=host.querySelector('[data-modal-body]');const wheels=new Map();let drag=null,sw=null,ignoreClick=0;
   const isUS=field=>host.draft[field+'US'];
   const read=s=>s.feet?Number(s.editor.querySelector('[name=feet]').value)*12+Number(s.editor.querySelector('[name=inches]').value):Number(s.editor.querySelector('input').value);
   function paint(s,residual=0){
    const step=s.track.clientWidth*.35;
    s.cells.forEach((cell,i)=>{const offset=i-2,n=s.value+offset,distance=offset*step+residual,emphasis=Math.max(0,1-Math.abs(distance)/Math.max(1,step));
     cell.textContent=n<s.min||n>s.max?'':s.feet?`${Math.floor(n/12)}′ ${n%12}″`:String(n);
     cell.style.transform=`translateX(${distance}px) scale(${.75+.25*emphasis})`;
     cell.style.color=emphasis>.5?'#000':'#ccc';
    });
    s.prev.disabled=s.value<=s.min;s.next.disabled=s.value>=s.max;
   }
   function commit(s,value){
    s.value=Math.max(s.min,Math.min(s.max,Math.round(value)));
    if(s.feet){s.editor.querySelector('[name=feet]').value=Math.floor(s.value/12);s.editor.querySelector('[name=inches]').value=s.value%12;}
    else s.editor.querySelector('input').value=s.value;
    host.syncDraft();
   }
   function settle(s){
    s.track.classList.remove('is-dragging');s.track.classList.add('is-settling');
    paint(s,0);clearTimeout(s.timer);s.timer=setTimeout(()=>s.track.classList.remove('is-settling'),170);
   }
   function decorate(field){
    const area=body.querySelector(`[data-${field}-controls]`);if(!area)return;
    const feet=field==='height'&&isUS(field),inputs=[...area.querySelectorAll('input')];
    const shell=document.createElement('div');shell.className='wo-value-wheel'+(feet?' is-feet':'');shell.dataset.valueField=field;
    shell.innerHTML='<button type="button" class="wo-value-arrow" data-value-step="-1" aria-label="−">‹</button><div class="wo-value-track"><div class="wo-value-editor"></div></div><button type="button" class="wo-value-arrow" data-value-step="1" aria-label="+">›</button>';
    const track=shell.querySelector('.wo-value-track'),editor=shell.querySelector('.wo-value-editor');
    inputs.forEach((input,i)=>{if(feet){const label=document.createElement('label'),small=document.createElement('small');small.textContent=i?'IN':'FT';label.append(input,small);editor.append(label);}else editor.append(input);});
    const cells=Array.from({length:5},(_,i)=>{const cell=document.createElement('span');cell.className='wo-value-cell';cell.dataset.offset=i-2;cell.setAttribute('aria-hidden','true');track.prepend(cell);return cell;});
    area.replaceChildren(shell);
    const min=feet?40:field==='weight'&&isUS(field)?45:Number(inputs[0].min),max=feet?94:Number(inputs[0].max);
    const s={field,feet,shell,track,editor,cells,min,max,prev:shell.firstElementChild,next:shell.lastElementChild};s.value=read(s);wheels.set(field,s);paint(s);
    host.valueSliderResize?.observe(track);
   }
   host.valueSliderResize=new ResizeObserver(()=>wheels.forEach(s=>paint(s)));
   function updateSwitch(field){
    const area=body.querySelector(`[data-${field}-controls]`),picker=area.nextElementSibling,us=isUS(field);
    picker.querySelectorAll('[data-unit]').forEach((b,i)=>b.setAttribute('aria-pressed',String(i===Number(us))));
    if(field==='height')picker.querySelectorAll('[data-unit]')[1].textContent='FEET';
    let toggle=picker.querySelector('[data-unit-toggle]');
    if(!toggle){toggle=document.createElement('button');toggle.type='button';toggle.className='wo-unit-switch';toggle.dataset.unitToggle=field;toggle.setAttribute('role','switch');toggle.setAttribute('aria-label',field==='height'?'CM / FEET':'KG / LBS');picker.append(toggle);}
    toggle.setAttribute('aria-checked',String(us));
   }
   function setUnit(field,us){
    if(isUS(field)===us)return;
    host.syncDraft();host.draft[field+'US']=us;
    body.querySelector(`[data-${field}-controls]`).innerHTML=field==='height'?host.heightControls():host.weightControls();
    const old=wheels.get(field);host.valueSliderResize.unobserve(old.track);clearTimeout(old.timer);
    decorate(field);updateSwitch(field);
   }
   ['height','weight'].forEach(field=>{decorate(field);updateSwitch(field);});
   body.addEventListener('click',e=>{
    const b=e.target.closest('button');if(!b)return;
    if(b.dataset.unit||b.dataset.unitToggle){e.preventDefault();e.stopImmediatePropagation();if(Date.now()<ignoreClick)return;
     const field=b.dataset.unit||b.dataset.unitToggle;setUnit(field,b.dataset.unit?b===b.parentElement.querySelectorAll('[data-unit]')[1]:!isUS(field));return;}
    if(b.dataset.valueStep){e.preventDefault();const s=wheels.get(b.closest('[data-value-field]').dataset.valueField);s.value=read(s);const old=s.value;commit(s,old+Number(b.dataset.valueStep));paint(s,(s.value-old)*s.track.clientWidth*.35);s.track.classList.add('is-dragging');void s.track.offsetWidth;settle(s);}
   },{signal,capture:true});
   const start=(target,x,y)=>{
    drag=null;sw=null;const toggle=target.closest('[data-unit-toggle]');if(toggle){sw={field:toggle.dataset.unitToggle,x,y};return;}
    const track=target.closest('.wo-value-track');if(!track)return;const s=wheels.get(track.closest('[data-value-field]').dataset.valueField);
    clearTimeout(s.timer);s.track.classList.remove('is-settling');s.value=read(s);drag={s,x,y,start:s.value,mode:null};
   };
   const move=(x,y,e)=>{
    if(sw){if(Math.abs(x-sw.x)>10&&Math.abs(x-sw.x)>Math.abs(y-sw.y)){e.preventDefault();sw.dx=x-sw.x;}return;}
    if(!drag)return;const g=drag,dx=x-g.x,dy=y-g.y;
    if(!g.mode&&Math.max(Math.abs(dx),Math.abs(dy))>8)g.mode=Math.abs(dx)>Math.abs(dy)*1.2?'x':'y';
    if(g.mode!=='x')return;e.preventDefault();g.s.track.classList.add('is-dragging');
    const step=g.s.track.clientWidth*.35;commit(g.s,g.start+Math.round(-dx/step));
    const residual=dx+(g.s.value-g.start)*step;paint(g.s,Math.max(-step*.5,Math.min(step*.5,residual)));
   };
   const end=e=>{
    if(sw?.dx){e.preventDefault();setUnit(sw.field,sw.dx>0);ignoreClick=Date.now()+500;}
    if(drag?.mode==='x'){e.preventDefault();settle(drag.s);}
    drag=null;sw=null;
   };
   body.addEventListener('touchstart',e=>{if(e.touches.length===1)start(e.target,e.touches[0].clientX,e.touches[0].clientY);else{drag=null;sw=null;}},{signal,passive:true});
   body.addEventListener('touchmove',e=>{if(e.touches.length===1)move(e.touches[0].clientX,e.touches[0].clientY,e);},{signal,passive:false});
   const cancel=()=>{if(drag?.mode==='x')settle(drag.s);drag=null;sw=null;};
   body.addEventListener('touchend',end,{signal,passive:false});body.addEventListener('touchcancel',cancel,{signal});
   body.addEventListener('pointerdown',e=>{if(e.pointerType!=='touch'&&e.button===0)start(e.target,e.clientX,e.clientY);},{signal});
   window.addEventListener('pointermove',e=>{if(e.pointerType!=='touch')move(e.clientX,e.clientY,e);},{signal});
   window.addEventListener('pointerup',e=>{if(e.pointerType!=='touch')end(e);},{signal});
   window.addEventListener('pointercancel',e=>{if(e.pointerType!=='touch')cancel();},{signal});
   body.addEventListener('input',e=>{const shell=e.target.closest('[data-value-field]');if(!shell||!e.target.validity?.valid||e.target.value==='')return;const s=wheels.get(shell.dataset.valueField);s.value=read(s);paint(s);},{signal});
   signal.addEventListener('abort',()=>wheels.forEach(s=>clearTimeout(s.timer)),{once:true});
  }
  proto.clearGallery=function(...args){this.valueSliderAbort?.abort();this.valueSliderResize?.disconnect();return clearGallery.apply(this,args);};
  proto.renderModal=function(...args){const result=renderModal.apply(this,args);setup(this);return result;};
 });
})();